// 3rd Party
import React from 'react';

// Components
import { IconButton } from '@/views/components/buttons';
import { FormattedMessageV2 } from '@/views/components/i18n';

// Utils
import { formatBytes, formatMessage } from '@/utils/i18n';

// Assets
import UploadedFile from '@/images/design-system-v2/upload/uploadedFile.svg';

type Props = {
  file: File;
  rejectionCode?: string;
  i18nBasePath: string;
  onRemove: (file: File) => void;
};

const FileDisplay: React.FC<Props> = ({ file, rejectionCode, i18nBasePath, onRemove }) => (
  <div className="uploaded-file">
    <div className="file-info">
      <img alt={formatMessage(`${i18nBasePath}.Alt.UploadedFileImage`)} src={UploadedFile} />
      <div>
        <div className="uploaded-file-name">{file?.name}</div>
        {!rejectionCode && <div className="uploaded-file-size">{formatBytes(file?.size)}</div>}
        {rejectionCode && (
          <div className="file-rejection-reason">
            <FormattedMessageV2 toLocalize={`${i18nBasePath}.Errors.${rejectionCode}`} />
          </div>
        )}
      </div>
    </div>

    <IconButton
      data-testid="remove-file-icon-button"
      aria-label="Remove File"
      icon="ds-delete-outline"
      className="icon-button-v2 secondary uploaded-file-delete"
      onClick={() => onRemove(file)}
    />
  </div>
);

export default FileDisplay;
